import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MediaSwiperComponent } from './media-swiper.component';

const routes: Routes = [{ path: '', component: MediaSwiperComponent }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MediaSwiperRoutingModule { }
